import i18n from '@/lang/i18n'

export default [
    {
        type: 'text',
        headerName: i18n.t('laboratory.tracking.report.portionId'),
        field: 'porLabel'
    },
    {
        type: 'text',
        headerName: i18n.t('laboratory.tracking.report.topographicCode'),
        field: 'sample.topographicCode.description'
    },
    {
        type: 'text',
        headerName: i18n.t('laboratory.tracking.report.pathologist'),
        field: 'sample.caseStudy.pathologist.fullName'
    }
]
